/**
 * Created by XuQiang on 2017/5/24.
 */
import React from 'react';
import { OPEN_LOGIN, SIGN_ACTIVE } from '../../utils/constants';
import { FormattedMessage } from 'react-intl';

export default ({ intl, dispatch, loginData }) => {
  const { register, registerError } = loginData;
  const { tips, msg } = registerError;
  return (
    <div className="fix-register">
      <div className="register-cont">
        <div className="register-title">
          <FormattedMessage id="index_registration" />
        </div>
        <div className={'register-type'}>
          <input
            type="text"
            placeholder={intl.formatMessage({ id: 'index_company_name' })}
            maxLength="100"
            value={register.name || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, name: t.target.value }
              })
            }
            onBlur={() =>
              inputOnBlur({
                value: register.name,
                registerError,
                dispatch,
                index: 0,
                msg: intl.formatMessage({ id: 'company_name_prompt' })
              })
            }
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 0 })}
          />
          {tips[0]}
        </div>
        <div className={'register-type'}>
          <input
            className="uname"
            type="text"
            placeholder={intl.formatMessage({ id: 'index_company_account' })}
            maxLength="16"
            value={register.userId || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, userId: t.target.value }
              })
            }
            onBlur={() => {
              const temp =
                register.domainName &&
                /^[a-zA-Z0-9_\\-\\. ()（）]+$/i.test(register.userId) &&
                /^[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(register.domainName) &&
                register.userId;
              inputOnBlur({
                value: temp,
                registerError,
                dispatch,
                index: 1,
                msg: intl.formatMessage({ id: 'reg_userId_prompt' })
              });
            }}
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 1 })}
          />
          <font>@</font>
          <input
            className="uname"
            type="text"
            placeholder={intl.formatMessage({ id: 'index_company_domain' })}
            maxLength="30"
            value={register.domainName || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, domainName: t.target.value }
              })
            }
            onBlur={() => {
              const temp =
                register.userId &&
                /^[a-zA-Z0-9_\\-\\. ()（）]+$/i.test(register.userId) &&
                /^[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(register.domainName) &&
                register.domainName;
              inputOnBlur({
                value: temp,
                registerError,
                dispatch,
                index: 1,
                msg: intl.formatMessage({ id: 'company_domain_prompt' })
              });
              if (temp) {
                dispatch({
                  type: 'login/validateDomain',
                  domainName: register.domainName
                });
              }
            }}
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 1 })}
          />
          {tips[1]}
        </div>
        <div className={'register-type'}>
          <input
            type="text"
            className="uname"
            placeholder={intl.formatMessage({ id: 'user_first_name' })}
            value={register.firstName || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, firstName: t.target.value }
              })
            }
            onBlur={() =>
              inputOnBlur({
                value: register.givenName && register.firstName,
                registerError,
                dispatch,
                index: 3,
                msg: intl.formatMessage({ id: 'reg_firstName_prompt' })
              })
            }
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 3 })}
            maxLength="20"
          />
          <font>&nbsp;&nbsp;&nbsp;&nbsp;</font>
          <input
            type="text"
            className="uname"
            placeholder={intl.formatMessage({ id: 'user_last_name' })}
            value={register.givenName || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, givenName: t.target.value }
              })
            }
            onBlur={() =>
              inputOnBlur({
                value: register.firstName && register.givenName,
                registerError,
                dispatch,
                index: 3,
                msg: intl.formatMessage({ id: 'reg_lastName_prompt' })
              })
            }
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 3 })}
            maxLength="20"
          />
          {tips[3]}
        </div>
        <div className={'register-type'}>
          <input
            placeholder={intl.formatMessage({ id: 'index_company_email' })}
            value={register.email || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, email: t.target.value }
              })
            }
            onBlur={() => {
              inputOnBlur({
                value:
                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    register.email
                  ) && register.email,
                registerError,
                dispatch,
                index: 4,
                msg: intl.formatMessage({ id: 'reg_email_prompt' })
              });
              /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                register.email
              ) &&
                dispatch({
                  type: 'login/validateUser',
                  user: {
                    num: register.email,
                    domainName: register.domainName,
                    flag: 3
                  }
                });
            }}
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 4 })}
            maxLength="37"
          />
          {tips[4]}
        </div>
        <div className={'register-type'}>
          <input
            placeholder={intl.formatMessage({ id: 'index_company_phone' })}
            value={register.mobile || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, mobile: t.target.value }
              })
            }
            onBlur={() => {
              inputOnBlur({
                value:
                  /^(\+|\d)\d{0,13}$/g.test(register.mobile) && register.mobile,
                registerError,
                dispatch,
                index: 5,
                msg: intl.formatMessage({ id: 'reg_tel_prompt' })
              });
              /^(\+|\d)\d{0,13}$/g.test(register.mobile) &&
                dispatch({
                  type: 'login/validateUser',
                  user: {
                    num: register.mobile,
                    domainName: register.domainName,
                    flag: 2
                  }
                });
            }}
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 5 })}
            maxLength="15"
          />
          {tips[5]}
        </div>
        <div className={'register-type'}>
          <input
            type="password"
            placeholder={intl.formatMessage({ id: 'index_password_prompt' })}
            value={register.password || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, password: t.target.value }
              })
            }
            onBlur={() =>
              inputOnBlur({
                value:
                  /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g.test(
                    register.password
                  ) && register.password,
                registerError,
                dispatch,
                index: 6,
                msg: intl.formatMessage({ id: 'reg_password_prompt' })
              })
            }
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 6 })}
          />
          {tips[6]}
        </div>
        <div className={'register-type'}>
          <input
            type="password"
            placeholder={intl.formatMessage({ id: 'index_password_conform' })}
            value={register.pwc || ''}
            onChange={t =>
              dispatch({
                type: 'login/setRegister',
                register: { ...register, pwc: t.target.value }
              })
            }
            onBlur={() =>
              inputOnBlur({
                value: register.pwc === register.password && register.pwc, //这里不需要^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g.test(register.pwc)
                registerError,
                dispatch,
                index: 2,
                msg:
                  (!register.pwc &&
                    intl.formatMessage({ id: 'reg_password_prompt' })) ||
                  (register.pwc !== register.password &&
                    intl.formatMessage({ id: 'password_different' }))
              })
            }
            onFocus={() => inputOnFocus({ registerError, dispatch, index: 2 })}
          />
          {tips[2]}
        </div>
        <p className="register-case">{msg}</p>

        <div className="register-btn">
          <button
            disabled={
              Object.keys(register).length < 9 ||
              registerError.tips.some(t => {
                if (t && t.props) {
                  return t.props.className === 'iconfont icon-x';
                } else {
                  return !t;
                }
              }) ||
              registerError.msg
            }
            onClick={() => {
              dispatch({
                type: 'login/setRegisterMobile',
                registerMobile: register.mobile
              });
              dispatch({ type: 'login/setDivType', divType: SIGN_ACTIVE });
            }}
          >
            <FormattedMessage id="index_next" />
          </button>
        </div>
        <div className="jump_link">
          <a
            className="lr"
            onClick={() =>
              dispatch({ type: 'login/setDivType', divType: OPEN_LOGIN })
            }
          >
            <FormattedMessage id="index_login2" />
          </a>
        </div>
      </div>
    </div>
  );
};

const inputOnBlur = ({ value, index, dispatch, registerError, msg }) => {
  if (!value) {
    registerError.tips[index] = <i className="iconfont icon-x" />;
    registerError.msg = msg;
  } else {
    registerError.tips[index] = <i className="iconfont icon-duihao" />;
    if (registerError.msg === msg) {
      registerError.msg = '';
    }
  }
  dispatch({ type: 'login/setRegisterError', registerError });
};

const inputOnFocus = ({ registerError, index, dispatch }) => {
  registerError.tips[index] = null;
  registerError.msg = '';
  dispatch({ type: 'login/setRegisterError', registerError });
};



// WEBPACK FOOTER //
// ./src/components/login/RegisterDiv.js